import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import imageIcon from '/imagenes/comentario-icono-limpiar-contenido.svg';

export default class LimpiarContenido extends Plugin {
    init() {
        const editor = this.editor;
        const t = editor.t;/* Usado para traducir t('texto a traducir')*/

        editor.ui.componentFactory.add( 'limpiarContenido', locale => {
            const view = new ButtonView( locale );

            view.set( {
                label: 'Limpiar',
                icon: imageIcon,
                tooltip: true
            } );
            
            view.on( 'execute', () => {
                editor.setData( '' );
            } );

            return view;

            /* cambiar diseño selector tamaño de texto
            const editor = this.editor;
            const t = editor.t;

            const command = editor.commands.get( 'fontSize' );

            // Use original fontSize button - we only changes its behavior.
            const dropdownView = editor.ui.componentFactory.create( 'fontSize' );

            // Show label on dropdown's button.
            dropdownView.buttonView.set( 'withText', true );

            // To hide the icon uncomment below.
            dropdownView.buttonView.set( 'icon', false );

            // Bind dropdown's button label to fontSize value.
            dropdownView.buttonView.bind( 'label' ).to( command, 'value', value => {
                // If no value is set on the command show 'Default' text.
                // Use t() method to make that string translatable.
                return value ? value : t( 'Default' );
            } );

            return dropdownView;
            */
        } );
    }
}